import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const retrieveBatch = createAsyncThunk(
  "batchDetails",
  async (arg, {rejectWithValue}) => {
    try {
      const response = await doPost(urls?.retrieveBatch, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const retrieveBatchSlice = createSlice({
  name: "batchDetails",
  initialState: {
    isLoading: false,
    error: null,
    success: false,
    data: false,
  },
  reducers: {
    retrieveBatchReset: () => {
      return {
        isLoading: false,
        error: null,
        success: false,
        data: false,
      };
    },
  },
  extraReducers: {
    [retrieveBatch.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
      state.data = payload;
      state.success = true;
    },
    [retrieveBatch.pending]: (state) => {
      state.isLoading = true;
      state.success = false;
      state.data = false;
    },
    [retrieveBatch.rejected]: (state,  {payload} ) => {
      state.isLoading = false;
      state.error = payload;
      state.data = false;
    },
  },
});

export const { retrieveBatchReset } = retrieveBatchSlice.actions;
